/**
 * Returns true when the local part of the email (before the first @) contains a plus sign (+).
 * Returns false for empty input, non-strings, or addresses without a well-formed local part
 * (e.g. missing `@`, or `@` at index 0). Those cases should be handled by the standard
 * email / required validators so users see “invalid email” rather than the plus-alias message.
 */
export function emailLocalPartContainsPlusSign(email: string): boolean {
  if (typeof email !== 'string') {
    return false;
  }
  const trimmed = email.trim();
  const atIndex = trimmed.indexOf('@');
  if (atIndex <= 0) {
    return false;
  }
  return trimmed.slice(0, atIndex).includes('+');
}
